import htmx from 'htmx.org';
window.htmx = htmx;

export default htmx;